// extracted by mini-css-extract-plugin
export default {"answer":"FroSbAQGvM2JEh7cQX3M hEPnLTDg_WWFuEYKpHso","question":"G8js5nnTT1yG8RjHzaCK"};